// Lib
import { SIZE_FULL } from '@/lib/gridElements/size';
import { classicFormat } from '@/hooks/format/useFormatNumber';

// Components
import { HalfBarChart } from '@/components/composite/Charts/HalfBarChart';

export const postEngagementHistoryConfig = {
    title: 'chart.facebook.post_engagements_history',
    tooltip: 'chart.facebook.post_engagements_history_tooltip',
    subtitle: 'chart.facebook.post_engagements_history_subtitle',
    id: 'post_engagements_history',
    margin: {
        left: -25,
        bottom: 20
    },
    orientation: 'horizontal',
    isStacked: true,
    name: {
        date: 'date',
        like: 'chart.post_reactions_facebook.like',
        love: 'chart.post_reactions_facebook.love',
        haha: 'chart.post_reactions_facebook.haha',
        sad: 'chart.post_reactions_facebook.sad',
        wow: 'chart.post_reactions_facebook.wow',
        angry: 'chart.post_reactions_facebook.angry'
    },
    valueFormat: classicFormat,
    size: SIZE_FULL,
    type: 'chart',
    element: HalfBarChart,
    customTick: { type: 'reactions' },
    color: {
        like: 'blue',
        love: 'red',
        wow: 'green',
        haha: 'yellow',
        sad: 'purple',
        angry: 'aquablue'
    }
};
